import { render } from "./RegistrationModal.vue?vue&type=template&id=bbaa27bc&scoped=true"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"

import "./RegistrationModal.vue?vue&type=style&index=0&id=bbaa27bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaa27bc"]])

export default __exports__